import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppAvatarEditor from "@/components/ui-kit/avatar-editor/AppAvatarEditor.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatAvatarModal',
  emits: ["save"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const $modal = ref<typeof BaseModal | null>(null)

const onOpen = () => {
	$modal.value?.onOpen();
}

const onSavePhoto = (url: string): void => {
	emit('save', url)
	$modal.value?.onClose();
}

__expose({ onOpen })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    "fullscreen-on-mobile": "",
    height: 656,
    width: 600
  }, {
    default: _withCtx(() => [
      _createVNode(AppAvatarEditor, { onSave: onSavePhoto })
    ]),
    _: 1
  }, 512))
}
}

})